<template>
    <div class="row">
        <div id="ticketsSpinner"></div>
        <div class="e-card mt-2">
            <div class="row">
                <div class="col-sm-2 mt-3">
                    <ejs-dropdownlist ref='dplCurrencyTrade' id="currencyTrade" name="currency" v-model="data.currencyId" :change="onCurrencyChangeTrade" :dataSource='currenciesTrade' :fields="{text: 'name', value: 'currencyId' }" placeholder="Currency" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                </div>
                <!--<div class="col-sm-2 mt-3 d-flex">
                    <ejs-checkbox ref="tradeCheckDM" :change="onCheckTradeDefault" label='Default Mechanism' id="TradeCheckDefault" name="checkName" floatLabelType='Auto' cssClass="tradeCheck check-d"></ejs-checkbox>
                </div>-->
                
                <div class="col-sm-7 mt-3">

                </div>
                <div class="col-sm-2 mt-3">
                    <ejs-button cssClass="e-primary btn-download" v-on:click.native='btnTradeReportDownload'>Trade Report</ejs-button>
                </div>
            </div>
            <div class="row">
                <div class="col m-3">
                    <ejs-grid ref='grid'
                              :dataSource='gridData'
                              :filterSettings='filterOptions'
                              :allowPaging='false'
                              :allowResizing='true'
                              :allowReordering='true'
                              :allowSorting='true'
                              :allowFiltering='true'
                              :autoFit='true'
                              :toolbarClick='toolbarClick'
                              :toolbar='toolbar'
                              :actionBegin ='actionBegin'
                              :actionComplete ='actionComplete'
                              :actionFailure ='actionFailure'
                               :queryCellInfo='customiseCell'>
                        <e-columns>
                            <e-column field='tradeReference' headerText='Trade ID' width=120></e-column>
                            <e-column field='tradeDate' headerText='Trade Date' type="date" :format='dateFormatOptions'></e-column>
                            <e-column field='ticketPeriod' headerText='Trade Period'></e-column>
                            <e-column field='product' headerText='Product'></e-column>
                            <e-column field='priceAreaName' headerText='Price Area' width=150></e-column>
                            <e-column headerText='Complex trade' field='isComplexGroup' textAlign="Center"></e-column>
                            <e-column headerText='Volume' :columns='volumeColumnes' textAlign="Center"></e-column>
                            <e-column field='price' headerText='Price' format="n3" textAlign="Center"></e-column>
                            <e-column field='tradedBy' headerText='Traded by' textAlign="Center"></e-column>
                            <e-column field='confirmationReference' headerText='Confirmation Reference' textAlign="Center"></e-column>
                            <e-column field='note' headerText='Supplementary Note' textAlign="Center"></e-column>
                            <!--<e-column headerText='Actions' width='150' textAlign='Center' :template='pdfTemplate'></e-column>-->
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Toolbar, Filter, Edit, Resize, Sort, Reorder } from "@syncfusion/ej2-vue-grids";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
    import apis from '../../common/network'
    import urls from '../../common/urls';
    import authToken from '../../common/authToken';
    import gridOptions from '../../common/gridOptions'
    import { Query } from '@syncfusion/ej2-data';
    import store from '../../store';
    import router from '../../router/index';
    import { ToastPlugin, Toast } from "@syncfusion/ej2-vue-notifications";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { isNullOrUndefined } from '@syncfusion/ej2-base';
    import { DialogUtility } from '@syncfusion/ej2-vue-popups';
    import { CheckBoxPlugin, CheckBox } from "@syncfusion/ej2-vue-buttons";
    import SyncHelper from '../../common/syncfusion';

    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(GridPlugin);
    Vue.use(CheckBoxPlugin);

    export default {
        name: 'TicketsReport',
        created() {
        },
        data() {
            return {
                gridData: {},
                firstIndexTrade: 3,
                unit: null,
                volumeColumnes: [
                    {
                        field: 'volumeInContractTradingUnit',
                        headerText: 'Trading Unit',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2"
                    },
                    {
                        field: 'volumeHedgedPercentage',
                        headerText: '%',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    }
                ],
                toolbar: [{ text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'AddTrades' }],
                filterOptions: gridOptions.filterSettings,
                allowFiltering: true,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                pdfTemplate: function () {
                    return {
                        template: Vue.component('columnTemplate', {
                            template: `<ejs-button cssClass='secondary' v-on:click.native="click(data)">Download</ejs-button>`,// <a :href="this.data.reportUrl" cssClass='e-block e-success'   download> Download</a>
                            data: function () {
                                return {
                                    data: {}
                                }
                            },
                            methods: {
                                click: function (args) {
                                    showSpinner(document.getElementById('mainSpinner'));
                                    apis.protectedApi(`${urls.apiBaseUrl}Trade/getTradePdfUrl/${args.tradeId}`,
                                        { responseType: 'blob' }).then(
                                            it => {
                                                var blob = new Blob([it.data], { type: 'application/' + it.headers['content-type'] })
                                                var downloadElement = document.createElement('a')
                                                var href = window.URL.createObjectURL(blob) // Create a downloaded link
                                                downloadElement.href = href
                                                downloadElement.download = "Trade_" + args.tradeId + ".pdf"; // filename after download
                                                document.body.appendChild(downloadElement)
                                                downloadElement.click() // Click to download
                                                document.body.removeChild(downloadElement)
                                                hideSpinner(document.getElementById('mainSpinner'));
                                            }).catch(
                                                response => {
                                                    var message = response.response.data.message != undefined ? response.response.data.message : "Trade does not have pdf file.";
                                                    gridOptions.errorAlert("Error: " + message);
                                                    hideSpinner(document.getElementById('mainSpinner'));
                                                }
                                            );
                                }
                            }
                        })
                    }
                }

            }
        },
  
        methods: {
            toolbarClick(args) {
                if (args.item.id === 'AddTrades' && store.state.permissions["Permissions.Trades.Create"]) {
                    router.push({ name: "Trade", params: { callerId: store.state.reportContractId, callerForm: "Reports UI", callerTab: "Trades" } });
                }
            },
            //onCheckTradeDefault(args) {
            //    store.state.isCheckDefaultM = args.checked; 
            //    let currencySymbol = document.getElementById('currencyTrade').value;
            //    this.getTradeData(currencySymbol);
            //},
            onCurrencyChangeTrade: function (args) {
                let currencyId = args.itemData.currencyId;
                this.getTradeData(currencyId);

            },
            getTradeData: function (currencyId) {
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`report/tradingReport/${store.state.reportContractId}?currencyId=${currencyId == undefined ? "" : currencyId}&defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}`)
                    .then(response => {
                        hideSpinner(document.getElementById('ticketsSpinner'));
                        this.gridData = response.data.result;
                        this.gridData.forEach(item => {
                            item.tradeDate = new Date(item.tradeDate);
                        });
                        this.unit = response.data.unit;

                        this.reutersPricingUnit = response.data.reutersPricingUnit;
                        this.$refs.tradeCheckDM.ej2Instances.checked = store.state.isCheckDefaultM;
                      
                        if (response.data.value == 'p/therm') {

                            this.$refs.dplCurrencyTrade.ej2Instances.text = "p - GBp";

                        } else {

                            this.$refs.dplCurrencyTrade.ej2Instances.text = response.data.currencySymbolAndName;
                        }
                        hideSpinner(document.getElementById('mainSpinner'))
                    }).catch(e => {
                        hideSpinner(document.getElementById('ticketsSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'))
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    })

            },     
            btnTradeReportDownload: function (args) {
                showSpinner(document.getElementById('ticketsSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                this.currencyId = this.$refs.dplCurrencyTrade.ej2Instances.value;
                apis.protectedApi(`${urls.apiBaseUrl}reportTemplate/generateTicketsReportPage/${store.state.reportContractId}?currencyId=${this.currencyId == undefined ? "" : this.currencyId}&defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('ticketsSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }).catch(
                    response => {
                        hideSpinner(document.getElementById('ticketsSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
            setToolbarVisibility: function () {
                if (!store.state.permissions["Permissions.Trades.Create"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['AddTrades'], false);
                }
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            customiseCell: function (args) {
                if (args.column.field === 'volumeInContractTradingUnit') {
                    args.cell.textContent = args.cell.textContent + " " + this.unit;
                }
                if (args.column.field === 'price') {
                    args.cell.textContent = args.cell.textContent + " " + this.reutersPricingUnit;
                }
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
                apis.protectedApi(`contract/getContractStatus?contractId=${store.state.reportContractId}`).then(it => {
                    if (it.data.data == false) {
                        this.$refs.grid.ej2Instances.toolbarModule.enableItems(['AddTrades'], false);
                    }
                }).catch(
                    response => {
                        hideSpinner(document.getElementById('ticketsSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );

            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args, this.$refs);
            }
        },
        mounted() {
            let spinner = document.getElementById('ticketsSpinner');
            createSpinner({
                target: spinner
            });
            showSpinner(spinner);
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            showSpinner(document.getElementById('mainSpinner'));
            this.getTradeData();
            this.setToolbarVisibility();
        },
        computed: {
            currenciesTrade() {
                return SyncHelper.getDataManager("utils/currenciesAvailable?contractId=" + store.state.reportContractId);
            },
        },
        provide: {
            grid: [Edit, Filter, Toolbar, Resize, Sort, Reorder]
        }
    }
</script>

<style>
    .btn-download {
        float: right;
        margin-top: 23px;
    }
    .d-flex{
        display: flex!important;
    }
    /*    .tradeCheck {
        margin: 25px 0px 0px 7px;
    }*/

    #ticketsSpinner {
        display: none;
    }
</style>